module.exports = __webpack_public_path__ + "img/doc-en.43b34048.png";